import React,{useEffect,useState} from 'react'
import styled  from 'styled-components'
import Navbar from '../components/Navbar'
import Announcement from '../components/Announcement'
import NewsLetter from '../components/NewsLetter'
import {useLocation} from "react-router-dom"
import { publicRequest ,userRequest } from '../requestMethod'
import { Add, Remove } from '@mui/icons-material'
import { mobile } from '../responses'
import axios from 'axios'
import Footer from '../components/Footer'
import { addProduct } from '../redux/cartRedux'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-hot-toast'
const Container=styled.div`
`
const Wrapper=styled.div`
  padding: 50px;
  ${mobile({padding:"10px",flexDirection:"column"})};

  display: flex;
`
const ImgContainer=styled.div`
  flex: 1;
  background-color: #e8f5fd8f;
`
const Image=styled.img`
  width: 100%;
  height: 90vh;
  object-fit: contain;
  ${mobile({height:"50vh"})};
  
  `
const InfoContainer=styled.div`
  flex: 1;
  padding: 0 50px;
  ${mobile({padding:"10px"})};
  `
const Title=styled.h1`
  font-weight: 200;
`
const Desc=styled.p`
  margin: 20px 0px;
`
const Price=styled.span`
  font-weight: 100;
  font-size: 40px;
  `

const FilterContainer=styled.div`
  display: flex;
  justify-content: space-between;
  width: 50%;
  margin: 30px 0px;
  ${mobile({width:"100%"})};

`
const Filter=styled.div`
  display: flex;
  align-items: center;
`
const FilterTitle=styled.span`
  font-size: 20px;
  font-weight: 200;
`
const FilterColor=styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${props=>props.color};
  margin-left: 10px;
  cursor: pointer;
  box-shadow: 0px 0px 2px 1px #887dd1 ;
`
const FilterSize=styled.select`
  margin-left: 10px;
  padding: 5px;
`
const FilterSizeOption=styled.option``

const AddContainer=styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mobile({width:"100%"})};

`


const AmountContainer=styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
`


const Amount=styled.span`
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #887dd1;
  display: flex;
  align-items: center;
  justify-content: center;
`

// const Add=styled.option``
// const Remove=styled.option``
const Button=styled.button`
  padding: 14px;
  border: 2px solid #887dd1;
  background-color: white;
  cursor: pointer;
  font-weight: 500;

  &:hover{
    background-color: #f8f4f4;
  }
`

const Product = () => {
  const data=useSelector(state=>state.cart)
  
  const dispatch=useDispatch()
  const location=useLocation();
  const productId=location.pathname.split('/')[2];
  // console.log({productId});
  const [quantity,setQuantity]=useState(1)
  const handleClick=()=>{
    // check if quantity is zero
    quantity &&
    dispatch(addProduct({...product,quantity,size,color}));
   quantity && toast.success(`${product?.title} added to the cart`);
  }
  const [product,setProduct]=useState()
  const [color,setColour]=useState("")
  const [size,setSize]=useState("")
  // console.log({size,colour,product});
  // console.log({...product,quantity,size,color});

  
  // const [quantity,setQuantity]=useState(1)
  useEffect(()=>{
    const getProduct=async()=>{

      try {
        const productSpecific=await publicRequest.get(`/products/find/${productId}`)
        console.log({productSpecific});
        
        setProduct(productSpecific.data.product)
        setSize(productSpecific.data.product.size[0])
        setColour(productSpecific.data.product.color[0])
      } catch (error) {
        console.log({error});
      }
    }
    getProduct()
  },[productId])

  const handleQuantity=(type)=>{
    if(type==='dec'){
      setQuantity(pre=>pre-1<0?0:pre-1);
    }
    else{
      setQuantity(pre=>pre+1);
    }
  }
  return (
    <Container>
       <Navbar/>
      <Announcement/>

      <Wrapper>
          <ImgContainer>             
              <Image src={product?.img } alt='Image Loading...'/>
          </ImgContainer>
          <InfoContainer>
            <Title>{product?.title || "Title loading..."}</Title>
            <Desc> { product?.desc +" \n  Lorem ipsum dolor sit amet consectetur adipisicing elit. Nam quis recusandae in cupiditate voluptatum laboriosam explicabo alias expedita nihil quaerat consequatur ratione possimus, nemo, delectus, fugiat tenetur totam! Harum, ut." ||  "Description loading..." }</Desc>
            <Price>&#8377;{product?.price ||  "Price loading..."}</Price>
            <FilterContainer>
              <Filter>
                <FilterTitle>Color</FilterTitle>
                {product?.color.map(clr=>(
                  <FilterColor key={clr} color={clr} onClick={()=>setColour(clr)}/>
                )) || "color loading..."}
              </Filter>

              <Filter>
                <FilterTitle>Size</FilterTitle>
                <FilterSize onChange={(e)=>setSize(e.target.value)}>
                {product?.size.map(size=>(
                  <FilterSizeOption key={size}>{size}</FilterSizeOption>
                )) || "size loading..."}
                </FilterSize>
              </Filter>
            </FilterContainer>
            <AddContainer >
                <AmountContainer>
                  <Remove onClick={()=>handleQuantity("dec")} className='muiIcon'/>
                  <Amount>{quantity}</Amount>
                  <Add onClick={()=>handleQuantity("inc")} className='muiIcon'/>
                </AmountContainer>
                <Button type='button' onClick={handleClick}>ADD TO CART</Button>
            </AddContainer>
          </InfoContainer>
      </Wrapper>

      <NewsLetter/>
      <Footer/>
    </Container>
  )
}

export default Product
